import { useEffect, useState, useSyncExternalStore } from "react";
import { routeLoading } from "@/lib/routeLoading";
import { cn } from "@/lib/utils";

/**
 * Attente d'une page chargée à la demande (`React.lazy`). Rien pendant
 * 300 ms, le cas courant, pour éviter un flash ; puis un « Chargement… »
 * discret, comme `RequireAuth`. Si le voile de chargement est déjà là
 * (`RouteLoadingOverlay`), c'est lui qui l'annonce : pas de doublon.
 */
export function RouteFallback({
  fullScreen = false,
}: {
  fullScreen?: boolean;
}) {
  const [visible, setVisible] = useState(false);
  const overlayShown = useSyncExternalStore(
    routeLoading.subscribe,
    routeLoading.isLoading,
    () => false,
  );
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div
      role="status"
      className={cn(
        "flex items-center justify-center",
        fullScreen ? "min-h-dvh bg-canvas" : "min-h-[50vh]",
      )}
    >
      {visible && !overlayShown && (
        <p className="animate-fade-in text-sm text-subtle-foreground">
          Chargement…
        </p>
      )}
    </div>
  );
}
